/* eslint-disable react/no-danger */
import React from 'react';
import DOMPurify from 'dompurify';
import formatSummary from './SummaryFormatting';
import { cn } from '@/lib/utils';

interface SimpleTextFormatterProps {
    value: string;
    className?: string;
}

const SimpleTextFormatter = ({ value, className }: SimpleTextFormatterProps) => {
    return (
        <div
            className={cn(
                'text-justify text-sm whitespace-pre-wrap [&>ul]:m-0 [&>ul]:p-0 [&>ul>li]:ml-[2ch] [&>ul>li]:pl-[2ch]',
                className,
            )}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(formatSummary(value)) }}
        />
    );
};

export default SimpleTextFormatter;
